
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from './HoldCoType';
import * as actions from './HoldCoActions';
import * as holdCoService from './HoldCoServices';

function* fetchHoldCoListSaga(action) {
  try {
    const response = yield call(holdCoService.fetchHoldCos, action.payload);
    yield put(actions.getHoldCoListSuccess(response.data));
  } catch (error) {
    yield put(actions.getHoldCoListFailure(error));
  }
}

// For get by id (edit)
function* fetchHoldCoByIdSaga(action) {
  try {
    const response = yield call(holdCoService.fetchHoldCoById, action.payload);
    yield put(actions.getHoldCoByIdSuccess(response.data));
  } catch (error) {
    yield put(actions.getHoldCoByIdFailure(error));
  }
}

// For delete
function* deleteHoldCoSaga(action) {
  try {
    const response = yield call(holdCoService.deleteHoldCo, action.payload);
    yield put(actions.deleteHoldCoSuccess(response.data));
  } catch (error) {
    yield put(actions.deleteHoldCoFailure(error));
  }
}

// For delete file
function* deleteHoldCoFileSaga(action) {
  try {
    const response = yield call(holdCoService.deleteHoldCoFile, action.payload);
    if (response.status === true) {
      yield put(actions.deleteHoldCoFileSuccess(response));
    } else {
      const errorMessage = response.responseMessage || 'Failed to delete file';
      yield put(actions.deleteHoldCoFileFailure(errorMessage));
    }
  } catch (error) {
    const errorMessage = error?.response?.responseMessage || error?.message || 'Failed to delete file';
    yield put(actions.deleteHoldCoFileFailure(errorMessage));
  }
}

// For save
function* saveHoldCoSaga(action) {
  try {
    const response = yield call(holdCoService.saveHoldingCompany, action.payload);
    if (response.status === true) {
      yield put(actions.saveHoldCoSuccess(response));
    } else {
      const errorMessage = response.responseMessage || 'Failed to save holding company';
      yield put(actions.saveHoldCoFailure(errorMessage));
    }
  } catch (error) {
    const errorMessage = error?.response?.responseMessage || error?.message || 'Failed to save holding company';
    yield put(actions.saveHoldCoFailure(errorMessage));
  }
}

export default function* HoldCoSaga() {
  yield takeLatest(types.GET_HOLDCO_LIST_REQUEST, fetchHoldCoListSaga);
  yield takeLatest(types.GET_HOLDCO_BY_ID_REQUEST, fetchHoldCoByIdSaga);
  yield takeLatest(types.DELETE_HOLDCO_REQUEST, deleteHoldCoSaga);
  yield takeLatest(types.DELETE_HOLDCO_FILE_REQUEST, deleteHoldCoFileSaga);
  yield takeLatest(types.SAVE_HOLDCO_REQUEST, saveHoldCoSaga);
}
